module.exports = __webpack_public_path__ + "img/4-light2x.bb95ac2a.png";